const MAIN_TITLE = "Kaylo";

export const setMetaTitle = (title?: string | null) => {
  document.title = `${(!!title && `${title} | `) || ""}${MAIN_TITLE}`;
};
